module.exports = __webpack_public_path__ + "assets/img/hintBg.99670652.png";